if (!customElements.get('product-quick-view')) {
  // Load once in the theme layout so dynamically fetched recently-viewed cards
  // get the same controls as server-rendered cards.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.wp-qv__share');
    if (!button) return;
    const url = button.dataset.shareUrl;
    const title = button.dataset.shareTitle || document.title;
    if (navigator.share) navigator.share({ title, url }).catch(() => {});
    else if (navigator.clipboard) navigator.clipboard.writeText(url).catch(() => {});
  });
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    document.querySelectorAll('.wp-qv[open]').forEach((modal) => modal.hide());
  });

  customElements.define('product-quick-view', class ProductQuickView extends HTMLElement {
    connectedCallback() {
      // Dawn moves the surrounding modal to <body>; reconnecting must not bind twice.
      if (this.initialized) return;
      this.variantInput = this.querySelector('[name="id"]');
      if (!this.variantInput) return;
      this.initialized = true;
      this.variants = new Map(Array.from(this.querySelectorAll('template[data-qv-variant]'),
        (template) => [template.dataset.qvVariant, template]));
      this.slides = Array.from(this.querySelectorAll('.wp-qv__slide'));
      this.mediaIds = this.slides.map((slide) => slide.dataset.mediaId);
      this.firstImage = this.slides[0]?.querySelector('img')?.cloneNode(true);
      this.radios = Array.from(this.querySelectorAll('.wp-qv__radio'));
      this.variantInput.addEventListener('change', () => this.updateVariant());
      this.updateVariant();
    }

    updateVariant() {
      const button = this.querySelector('[name="add"]');
      if (button.classList.contains('loading')) {
        this.variantInput.value = this.currentVariant;
        return;
      }
      const template = this.variants.get(this.variantInput.value);
      if (!template) return;
      this.currentVariant = this.variantInput.value;
      const variant = template.dataset;
      // These money strings are supplied by Liquid, including any HTML in the
      // shop's money format. Preserve that formatting just like the product page.
      this.querySelector('[data-qv-price]').innerHTML = variant.price;
      for (const [selector, text] of [['[data-qv-compare]', variant.compare], ['[data-qv-discount]', variant.discount]]) {
        const element = this.querySelector(selector);
        element.innerHTML = text;
        element.hidden = !text;
      }

      const available = variant.available === 'true';
      button.disabled = !available;
      button.querySelector('span').textContent = available ? 'Add to Cart' : 'Sold Out';
      if (available) button.removeAttribute('aria-disabled');
      else button.setAttribute('aria-disabled', 'true');
      const availability = this.querySelector('[data-qv-availability]');
      availability.textContent = available ? 'In Stock' : 'Out of Stock';
      availability.className = available ? 'wp-qv__in-stock' : 'wp-qv__out-stock';
      this.querySelector('[data-qv-payment]').hidden = !available;
      const productForm = this.querySelector('product-form');
      productForm.error = false;
      this.querySelector('.product-form__error-message-wrapper').hidden = true;

      const quantity = this.querySelector('[name="quantity"]');
      quantity.min = variant.min;
      quantity.step = variant.step;
      quantity.dataset.min = variant.min;
      if (variant.max) quantity.max = variant.max;
      else quantity.removeAttribute('max');
      // Keep a shopper's quantity when it satisfies the new variant's rules.
      if (!quantity.checkValidity()) quantity.value = variant.min;
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
      if (!variant.max) this.querySelector('[name="plus"]').classList.remove('disabled');

      // Restore the first slide before selecting another variant. Variants whose
      // images fall outside the six previews use that slot, keeping the gallery size.
      if (this.firstImage) this.slides[0].replaceChildren(this.firstImage.cloneNode(true));
      let index = this.mediaIds.indexOf(variant.mediaId);
      if (index < 0) {
        index = 0;
        const image = template.content.querySelector('img');
        if (image && this.firstImage) this.slides[0].replaceChildren(image.cloneNode(true));
      }
      if (this.radios[index]) this.radios[index].checked = true;
      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', this.currentVariant);
      this.querySelectorAll('.wp-qv__view-full, .wp-qv__title a').forEach((link) => { link.href = url.href; });
    }
  });
}
